module.exports = __webpack_public_path__ + "website/img/yoyo15.969139d8.jpg";